import { render } from "./MdvArticle.vue?vue&type=template&id=d54052c8&scoped=true"
import script from "./MdvArticle.vue?vue&type=script&lang=js"
export * from "./MdvArticle.vue?vue&type=script&lang=js"

import "./MdvArticle.vue?vue&type=style&index=0&id=d54052c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54052c8"]])

export default __exports__